import { token } from '@/theme';
import { breakpoints } from '@/utils/util-breakpoints';
import styled from 'styled-components';

export const StageCard = styled.div<{ $isTransparent?: boolean }>`
  display: flex;
  align-items: center;
  position: relative;
  min-height: 38px;
  max-height: ${({ theme: { token } }) => token.fontSizeHeading1}px;
  background-color: ${({ $isTransparent, theme: { token } }) =>
    $isTransparent ? 'transparent' : token.colorBgContainer};
  padding: ${({ theme: { token } }) => token.paddingMD}px;
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  margin: ${({ theme: { token } }) => token.marginMD}px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  word-wrap: break-word;
  overflow-wrap: break-word;

  .station-stages-container {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.paddingMD}px;

    .favourite-star-spinner {
      width: 24px;
      height: 24px;
    }
  }

  .station-stage {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-shrink: 0;
    flex-wrap: wrap;
    min-width: 0;
  }

  .station-stage-space {
    flex: 1;
    justify-content: space-between;
    align-items: center;
    display: flex;
    min-width: 0;
    gap: ${({ theme: { token } }) => token.paddingSM}px;
    flex-wrap: wrap;

    .station-stage-skeleton {
      width: fit-content;
    }
  }

  .station-status-tag {
    transform: scale(1.2);
    margin-right: ${({ theme: { token } }) => token.marginLG}px;
    flex-shrink: 0;
  }

  @media (max-width: ${breakpoints.md}px) {
    flex-wrap: wrap;
    background-color: ${({ $isTransparent, theme: { token } }) =>
      $isTransparent ? 'transparent' : token.colorBgContainer};
    margin-top: 10px;
    gap: ${({ theme: { token } }) => token.paddingSM}px;

    .station-stage-space {
      margin-top: ${({ theme: { token } }) => token.paddingXS}px;
      flex-wrap: wrap;
      background-color: ${({ theme: { token } }) => token.fillQuaternary};
      gap: ${({ theme: { token } }) => token.paddingSM}px;
      justify-content: center;
    }

    .station-stage {
      flex-wrap: wrap;
      gap: ${({ theme: { token } }) => token.paddingSM}px;
    }

    .station-status-tag {
      transform: none;
      margin-right: 0;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const StateLabel = styled.span`
  color: ${({ theme }) => theme.token.colorTextSecondary};
`;

export const Stage = styled.div`
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ color }) => color ?? token.colorTextTertiary};
`;

export const ModalContent = styled.div`
  ul {
    padding-left: ${({ theme: { token } }) => token.paddingMD}px;
    list-style-type: disc;
  }
`;

export const HeaderItem = styled.div`
  color: ${({ theme }) => theme.token.colorTextSecondary};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    gap: 4px;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 375px) {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    gap: 2px;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 320px) {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    gap: 1px;
  }
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 180px;
  min-width: 0;
  flex-shrink: 0;
  max-width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 150px;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  }
`;

export const ContentWrapper = styled.div<{ $isSccPath?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  padding: 0px ${({ theme: { token } }) => token.paddingXXS}px 0px ${({ theme: { token } }) => token.paddingLG}px;

  .eco-select-station {
    min-width: ${({ theme: { token } }) => token.marginXL * token.marginXS}px;
  }

  @media (max-width: ${breakpoints.xl}px) {
    flex-direction: ${({ $isSccPath }) => ($isSccPath ? 'column-reverse' : 'column')};
    padding: ${({ theme: { token } }) => token.padding}px;

    .eco-select-station {
      width: 100%;
    }
  }
`;
